var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40.131,
    height: 45.185,
    viewBox: "0 0 40.131 45.185",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3851",
    "data-name": "Rectangle 3851",
    width: 40.131,
    height: 45.185,
    transform: "translate(0)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6753",
    "data-name": "Group 6753",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1003",
    "data-name": "Ellipse 1003",
    cx: 6.45,
    cy: 9.683,
    rx: 6.45,
    ry: 9.683,
    transform: "translate(16.14 18.228)",
    fill: "#ffce51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17665",
    "data-name": "Path 17665",
    d: "M277.124,213.954c-2.7-7.525-12.315-7.932-9.992-18.868a.884.884,0,0,0-1.291-1.015c-6.244,3.948-10.732,11.86-6.965,22.223.308.85-.619,1.644-1.291,1.089-3.112-2.526-3.44-6.159-3.165-8.761a.859.859,0,0,0-1.566-.626,18.287,18.287,0,0,0-2.356,9.682c.655,10.328,8.789,13.5,11.712,13.907,4.18.569,8.7-.26,11.954-3.45A13.4,13.4,0,0,0,277.124,213.954Zm-15.961,9.275a5.52,5.52,0,0,0,4.095-4.258c.567-2.638-1.651-5.22-.157-9.39.57,3.45,5.625,5.607,5.625,9.369C270.864,223.619,266.152,227.62,261.163,223.229Z",
    transform: "translate(-244.251 -190.931)",
    fill: "#ff7324"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.b3286e124caec148558ec2c9598deb14.svg";
export { ForwardRef as ReactComponent };